import React from "react";
import { not } from "@insightfulscience/shared-utils/validation";
import { isFunc } from "@insightfulscience/shared-utils/fn";

const isNotEqual = not(Object.is);

function useWatch(value, callback, condition = isNotEqual) {
	const valueRef = React.useRef(value);

	React.useEffect(
		() => {
			if (isFunc(callback) && condition(value, valueRef.current)) {
				callback(value, valueRef.current);
			}
			valueRef.current = value;
		},
		[value], // watch for value to apply effect
	);
}

export default useWatch;
